import React from 'react';
import { Image as RebassImage } from 'rebass';

const Image = props => <RebassImage {...props} />;

export default Image;
